import React from 'react';
import { Bookmark } from 'lucide-react';
import { cn } from '../../../utils/cn';

interface ImportantBadgeProps {
  isImportant?: boolean;
}

export function ImportantBadge({ isImportant = false }: ImportantBadgeProps) {
  return (
    <Bookmark 
      className={cn(
        "h-4 w-4 transition-colors",
        isImportant 
          ? "text-yellow-600 fill-current" 
          : "text-gray-400 hover:text-gray-600"
      )} 
    />
  );
}